// Баннер «доступна новая версия».
//
// Контролируемое обновление (`offline-first.md` §2): бандл уже скачан и проверен,
// но применяется — с перезагрузкой webview — только по нажатию. Посреди печати
// человек на кнопку не нажмёт, а само оно не перезагрузится.
//
// Появляется, только когда бандл в состоянии `ready`: до этого показывать нечего,
// а «проверяем…» и «качаем…» — шум, обновление доедет само.
//
// Это СТРОКА ШАПКИ под навигацией (AppLayout), а не плавающий слой. Слоем он висел
// у нижней кромки, поднятый на 72px «над панелью навигации киоска». Панель потом
// уехала наверх, а внизу остался липкий футер печати — выше и без постоянной высоты.
// На телефоне 360dp баннер лёг на «Печать этикетки» и «Ещё» (2026-09-27, обновление
// 0.2.31 → 0.2.32).
//
// Тот же класс дефекта, что у тоста (`shared/ui/Toast.tsx`): внизу экрана печати
// места нет ни при какой вёрстке. Но тост — ответ на только что сделанное действие:
// закрывается крестиком и уходит вместе с окном отмены (до пяти минут), а баннер
// висит, пока не нажмут, — слой поверх шапки на всё это время закрыл бы бургер.
// Поэтому своя строка: занимает собственное место и не перекрывает ничего — ни футер,
// ни тосты, ни индикатор синка, ни модальные окна.

import { Button } from '@restomarker/ui-kit';
import type { ReactElement } from 'react';

import { t } from '@/shared/i18n';

import { useAppUpdate } from './useAppUpdate';
import styles from './updateBanner.module.css';

export function UpdateBanner(): ReactElement | null {
  const update = useAppUpdate();

  if (!update.ready && !update.applying) {
    return null;
  }

  // Кнопка — ink (`primary`): применение и есть единственное действие строки.
  // Кнопка печати при этом остаётся самой крупной целью экрана — 72px во всю ширину
  // против обычного размера здесь, — как и у «Проверено» в напоминании о полках.
  return (
    <div className={styles.banner} role="status">
      <p className={styles.text}>{t('update.available')}</p>
      <Button variant="primary" onClick={update.apply} disabled={update.applying}>
        {update.applying ? t('update.applying') : t('update.apply')}
      </Button>
    </div>
  );
}
